const ARTICLE_UNIT_SHORT_LABELS = Object.freeze(new Map([
  [1, 'Stk'],
  [2, 'kg'],
  [3, 'gr'],
  [4, 'Std'],
  [5, 'Min'],
  [6, 'lt'],
  [7, 'dl'],
  [8, 'Eht'],
  [9, ''],
  [10, 'B100'],
  [11, 'P10'],
  [12, 'P20'],
  [13, 'P50'],
  [14, 'P100'],
  [15, 'P250'],
  [16, 'P500'],
  [17, 'Weg'],
  [18, 'Pos'],
  [19, 'Pal'],
  [20, 'Pau'],
  [21, 'inkl'],
  [30, 'km'],
  [31, 'm'],
  [32, 'cm'],
  [33, 'mm'],
  [34, 'm2'],
  [35, 'Lfm'],
  [36, 'm3'],
  [40, 'User'],
  [41, 'Jahr'],
  [50, 'fl'],
  [51, 'fa'],
  [52, 'K1'],
  [53, 'K3'],
  [54, 'K6'],
  [55, 'F50'],
  [56, 'F75'],
  [57, 'F150'],
  [58, 'K6'],
  [59, 'F100'],
  [60, 'ml'],
  [61, 'ppm'],
  [62, '%'],
  [63, 'Bund'],
  [64, 'Roll']
]));

function normalizeArticleUnitCode(value) {
  if (value == null || value === '') return null;
  const number = Number(String(value).trim().replace(',', '.'));
  if (!Number.isFinite(number)) return null;
  return Math.trunc(number);
}

function resolveArticleUnitShortLabel(value) {
  const code = normalizeArticleUnitCode(value);
  if (code == null) return '';
  return ARTICLE_UNIT_SHORT_LABELS.get(code) ?? '';
}

export {
  ARTICLE_UNIT_SHORT_LABELS,
  normalizeArticleUnitCode,
  resolveArticleUnitShortLabel
};
